import React from "react";
import Box from "../components/mui/Box";
import { styled } from '@mui/system';


const style = (Element = Box) =>{
    return (css={}) =>{
        return styled(Element)(css);
    }
}

export default style;